import { searchStateData } from '../../../data/searchStateData';
import { useAppSelector } from '../../../redux/hooks'
import { SearchOptionTypes } from '../../../types/types'
import './style.scss'
import { useAppDispatch } from '../../../redux/hooks/index';
import { setQuickSearchSelectionActive, setQuickSearchSelectionHoverIndex, setQuickSearchSelectionIndex, toggleQuickSearchSelectionHover, updateQuickSearchValues } from '../../../redux/reducers/searchSlice';
import SingleSelectPopUp from '../../selectPopUps/singleSelectPopUp/SingleSelectPopUp';
import { useState } from 'react';
import ListSelectPopUp from '../../selectPopUps/listSelectPopUp/ListSelectPopUp';
import RangeSelectPopUp from '../../selectPopUps/rangeSelectPopUp/RangeSelectPopUp';

interface QuickSearchOptionProps {
	index: number // index of this search button to update display based on active values in search redux
}

function QuickSearchOption({index}: QuickSearchOptionProps) {
	const [currentValue, setCurrentValue] = useState<number | string | number[] | undefined>(searchStateData.quickSearchOptions[index].value)
	const [inputValue, setInputValue] = useState<string | undefined>(undefined)

	const quickSearchSelectionIndex = useAppSelector(state => state.search.quickSearchSelectionIndex)
	const quickSearchSelectionActive = useAppSelector(state => state.search.quickSearchSelectionActive)
	const quickSearchSelectionHover = useAppSelector(state => state.search.quickSearchSelectionHover)
	const quickSearchSelectionHoverIndex = useAppSelector(state => state.search.quickSearchSelectionHoverIndex)
	
	const useMobileLayout = useAppSelector(state => state.resize.useMobileLayout)

	const dispatch = useAppDispatch()

	const optionClickHandler = () => {
		dispatch(setQuickSearchSelectionActive(quickSearchSelectionActive ? quickSearchSelectionIndex !== index : true))
		dispatch(setQuickSearchSelectionIndex(index))
	}

	const optionUnSelectHandler = () => {
		if (!currentValue || currentValue === '') {
			searchStateData.quickSearchOptions[index].value = undefined
			setCurrentValue(undefined)
		}
		dispatch(updateQuickSearchValues())
		dispatch(setQuickSearchSelectionActive(false))
	}

	const valueChangedHandler = (newValue: number | string | number[] | undefined) => {
		if (searchStateData.quickSearchOptions[index].value === newValue) {
			searchStateData.quickSearchOptions[index].value = undefined
		} else {
			searchStateData.quickSearchOptions[index].value = newValue
		}
		setCurrentValue(searchStateData.quickSearchOptions[index].value)
		dispatch(updateQuickSearchValues())
		// dispatch(setQuickSearchSelectionActive(false))
	}

	const getDisplayValue = (): string => {
		if (searchStateData.quickSearchOptions[index].value === undefined) {
			return searchStateData.quickSearchOptions[index].defaultValueText
		} else {
			if (typeof currentValue === 'string') {
				return currentValue
			} else if (typeof currentValue === 'number') {
				return searchStateData.quickSearchOptions[index].valueLabels[currentValue]
			} else if (typeof currentValue === 'object') {
				// Check if the current value is an array of numbers
				if (currentValue.length && currentValue.length > 0) {
					return `${searchStateData.quickSearchOptions[index].valueLabels[currentValue[0]]}${currentValue.length > 1 ? ' - ' + searchStateData.quickSearchOptions[index].valueLabels[currentValue[1]] : ''}`
				}
			}
		}
		return '?'
	}

	const hoverToggle = (index: number) => {
		dispatch(toggleQuickSearchSelectionHover())
		dispatch(setQuickSearchSelectionHoverIndex(index))
	}

	const showSeperator = () => {
		if (!useMobileLayout && index > 0) {
			if (quickSearchSelectionActive) {
				if (quickSearchSelectionIndex === index || quickSearchSelectionIndex + 1 === index) {
					return false
				}
			}
			if (quickSearchSelectionHover) {
				if (quickSearchSelectionHoverIndex === index || quickSearchSelectionHoverIndex + 1 === index) {
					return false
				}
			}
			return true
		}
		return false
		// {quickSearchSelectionActive ? 
		// 	!useMobileLayout && index !== 0 && quickSearchSelectionIndex !== index && quickSearchSelectionIndex + 1 !== index && 
		// 		<div className='quick-search-option-seperator' />
		// 	: quickSearchSelectionHover ?
		// 		!useMobileLayout && index !== 0 && quickSearchSelectionHoverIndex !== index && quickSearchSelectionHoverIndex + 1 !== index &&
		// 			<div className='quick-search-option-seperator' />
		// 		: !useMobileLayout && index !== 0 &&
		// 			<div className='quick-search-option-seperator' />
		// }
	}

	return (
		<div 
			className={`quick-search-option ${quickSearchSelectionActive && index === quickSearchSelectionIndex ? 'editing' : ''} optionType ${searchStateData.quickSearchOptions[index].optionType !== SearchOptionTypes.RANGE ? 'wide' : ''}`}
			onMouseEnter={() => hoverToggle(index)}
			onMouseLeave={() => hoverToggle(index)}
		>
			<div className='quick-search-option-label'>{searchStateData.quickSearchOptions[index].label}</div>
			{searchStateData.quickSearchOptions[index].optionType === SearchOptionTypes.TEXT ? 
				<>
					<input 
						className='quick-search-option-value'
						type='text'
						onFocus={() => {
							if (inputValue === undefined) {
								setInputValue('')
							}
							optionClickHandler()
						}}
						onBlur={(evt) => {
							if (evt.target.value === '') {
								setInputValue(undefined)
							}
							optionUnSelectHandler()
						}}
						onChange={(evt) => {
							setInputValue(evt.target.value)
							valueChangedHandler(evt.target.value)
						}}
						// value={inputValue !== undefined ? inputValue : searchStateData.quickSearchOptions[index].defaultValueText}
						value={inputValue}
						placeholder={searchStateData.quickSearchOptions[index].defaultValueText}
					/>
				</> : <>
					<div className='quick-search-option-value'>{getDisplayValue()}</div>
					<div className='quick-search-option-click-overlay' onClick={optionClickHandler} />
				</>
			}
			{quickSearchSelectionActive && quickSearchSelectionIndex === index && searchStateData.quickSearchOptions[index].optionType === SearchOptionTypes.SINGLE_FROM_RANGE
			&& (
				<SingleSelectPopUp
					label={searchStateData.quickSearchOptions[index].label}
					valueLabels={searchStateData.quickSearchOptions[index].valueLabels}
					currentValueIndex={currentValue !== undefined ? currentValue as number : undefined}
					onValueSelected={(selectedValue: number) => valueChangedHandler(selectedValue)}
				/>
			)}
			{quickSearchSelectionActive && quickSearchSelectionIndex === index && searchStateData.quickSearchOptions[index].optionType === SearchOptionTypes.RANGE
			&& (
				<RangeSelectPopUp
					label={searchStateData.quickSearchOptions[index].label}
					valueLabels={searchStateData.quickSearchOptions[index].valueLabels}
					currentValueIndexes={currentValue !== undefined ? currentValue as number[] : undefined}
					onValueSelected={(selectedValues: number[] | undefined) => valueChangedHandler(selectedValues)}
				/>
			)}
			{quickSearchSelectionActive && quickSearchSelectionIndex === index && searchStateData.quickSearchOptions[index].optionType === SearchOptionTypes.LIST && (
				<ListSelectPopUp
					label={searchStateData.quickSearchOptions[index].label}
					values={searchStateData.quickSearchOptions[index].valueLabels}
					currentValueIndex={currentValue !== undefined ? currentValue as number : undefined}
					onValueSelected={(selectedValue: number) => valueChangedHandler(selectedValue)}
				/>
			)}
			{showSeperator() &&
				<div className='quick-search-option-seperator' />
			}
			{/* {quickSearchSelectionActive ? 
				!useMobileLayout && index !== 0 && quickSearchSelectionIndex !== index && quickSearchSelectionIndex + 1 !== index && 
					<div className='quick-search-option-seperator' />
				: quickSearchSelectionHover ?
					!useMobileLayout && index !== 0 && quickSearchSelectionHoverIndex !== index && quickSearchSelectionHoverIndex + 1 !== index &&
						<div className='quick-search-option-seperator' />
					: !useMobileLayout && index !== 0 &&
						<div className='quick-search-option-seperator' />
			} */}
		</div>
	)
}

export default QuickSearchOption
